import { Controller } from "@hotwired/stimulus"

export default class ImagePreviewController extends Controller {
  static targets = ["input", "image", "removeFlag", "removeButton"]

  declare readonly inputTarget: HTMLInputElement
  declare readonly imageTarget: HTMLImageElement
  declare readonly removeFlagTarget: HTMLInputElement
  declare readonly removeButtonTarget: HTMLButtonElement
  declare readonly hasRemoveButtonTarget: boolean
  declare originalSrc: string

  connect() {
    this.originalSrc = this.imageTarget.src
  }

  preview() {
    const file = this.inputTarget.files?.[0]

    if (file) {
      const reader = new FileReader()

      reader.onload = (e) => {
        if (e.target?.result) {
          this.imageTarget.src = e.target.result as string
        }
      }

      reader.readAsDataURL(file)
      this.removeFlagTarget.value = "0"
    }
  }

  openFileDialog() {
    this.inputTarget.click()
  }

  removePhoto() {
    const defaultImage = this.hasRemoveButtonTarget
      ? this.removeButtonTarget.dataset.defaultImage
      : null

    if (defaultImage) {
      this.imageTarget.src = defaultImage
    }

    this.inputTarget.value = ""
    this.removeFlagTarget.value = "1"
  }

  reset() {
    this.imageTarget.src = this.originalSrc
    this.inputTarget.value = ""
    this.removeFlagTarget.value = "0"
  }
}
